import { render, staticRenderFns } from "./consultationAwnser.vue?vue&type=template&id=dbf4ba34"
import script from "./consultationAwnser.vue?vue&type=script&lang=js"
export * from "./consultationAwnser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports